<template src="./template.html"></template>
<style src="./styles.scss" lang="scss"></style>

<script>
import { mapState, mapActions } from 'vuex'
import ProfileTopLeftSection from '@/views/ProfilePage/variants/profileSections/ProfileTopLeftSection'
import ProfileTopRightSection from '@/views/ProfilePage/variants/profileSections/ProfileTopRightSection'
import ProfilePageTopSection from '@/views/ProfilePage/variants/profileSections/ProfilePageTopSection'
import ProfileVariantEditView from '@/views/ProfilePage/variants/ProfileVariantEditView'
import ProfileSectionView from '@/views/ProfilePage/ProfileSectionView'
import CooperationRequestOverlay from '@/components/overlays/CooperationRequestOverlay'

export default {
  name: 'ProfileVariantFullView',
  components: {
    CooperationRequestOverlay,
    ProfileSectionView,
    ProfileVariantEditView,
    ProfilePageTopSection,
    ProfileTopRightSection,
    ProfileTopLeftSection,
  },
  props: {
    religions: Object,
    topics: Array,
    isOwn: Boolean,
    isAdminUrl: String,
    canEdit: String,
  },
  data() {
    return {
      showProfileInEditView: false,
      openOverlay: false,
      avatarStyleClass: '',
      isStatusVisible: false,
    }
  },
  computed: {
    ...mapState('users', [
      'invoiceAddress',
      'deliveryAddress',
      'user',
      'userTopics',
      'userChildren',
      'userCustomFields',
    ]),
  },
  watch: {
    '$route.params.id'(value) {
      this.getInvoiceAddress(value)
      this.getDeliveryAddress(value)
    },
  },
  created() {
    this.getInvoiceAddress(this.$route.params.id)
    this.getDeliveryAddress(this.$route.params.id)
  },
  methods: {
    ...mapState('auth', ['settings']),
    ...mapActions('users', [
      'getInvoiceAddress',
      'getDeliveryAddress',
    ]),
    showStatusMessage() {
      this.isStatusVisible = true
    },
    userConversation() {
      this.$emit('userConversation')
    },
    closeOverlay() {
      this.openOverlay = false
    },
    toggleOverlay() {
      this.openOverlay = true
    },
  },
}
</script>
